export default __webpack_public_path__ + "static/backgroundWhite-75daa90bd4452b1193d86f20f29400f2.webp";